import { render, staticRenderFns } from "./BusinessLogo-Profile.vue?vue&type=template&id=2c6ee5a4"
import script from "./BusinessLogo-Profile.vue?vue&type=script&lang=js"
export * from "./BusinessLogo-Profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports